module.exports = __webpack_public_path__ + "img/companies.5e918331.svg";